export default __webpack_public_path__ + "static/media/close_btn_normal_light.8b03ef2e.svg";